<template>
  <div style="position: relative">
    <div v-if="loading" class="progress-bar">
      <div class="progress-bar-value"></div>
    </div>
    <div v-if="loading" class="loading-overlay"></div>
    <b-tabs v-model="activeTab" class="w-100">
      <b-tab>
        <template #title>
          <h4 class="header-title-h">
            <feather-icon size="20" icon="" />الأنشطة الأساسية
          </h4>
        </template>
        <hr />
        <alert
          massage="عذراً لا يوجد سجلات لعرضها"
          class="w-100"
          v-if="activities.length == 0"
        ></alert>
        <app-collapse v-else>
          <activity-collapse
            v-for="activity in activities"
            :key="activity.id"
            :title="activity.name"
            @editClicked="openEditActivityModal(activity)"
            @deleteClicked="onDeleteActivity(activity)"
          >
            <b-container>
              <b-row class="justify-content-start">
                <b-col cols="12">
                  <h4 class="">
                    <feather-icon
                      class="align-middle"
                      size="20"
                      icon="FileTextIcon"
                    />
                    المعلومات الأساسية
                  </h4>
                </b-col>

                <b-col
                  lg="6"
                  sm="12"
                  v-for="(item, key) in mainInfo"
                  :key="key"
                >
                  <info-card :label="item.label" :value="activity[key]" />
                </b-col>
                <b-col lg="6" sm="12">
                  <info-card
                    :label="selectedInfo.services.label"
                    :value="
                      activity['activityServices']
                        .map((el) => el.name_ar)
                        .join(' , ')
                    "
                  />
                </b-col>
                <b-col lg="6" sm="12">
                  <info-card
                    :label="selectedInfo.ageCategories.label"
                    :value="
                      activity['categories'].map((el) => el.name_ar).join(' , ')
                    "
                  />
                </b-col>
                <b-col lg="6" sm="12">
                  <info-card
                    :label="selectedInfo.program.label"
                    :value="activity['program'] ? activity['program'].name : ''"
                  />
                </b-col>
              </b-row>
            </b-container>
          </activity-collapse>
          <pagination
            @input="currentPage = $event"
            :total-rows="pagination.total_row"
            :per-page="pagination.per_page"
            :value="parseInt(pagination.current_page)"
            align="end"
          >
          </pagination>
        </app-collapse>
      </b-tab>
      <b-tab>
        <template #title>
          <h4 class="header-title-h">
            <feather-icon size="20" icon="" />الأنشطة الطارئة
          </h4>
          <hr />
        </template>
        <hr />
        <Alert
          massage="عذراً لا يوجد سجلات لعرضها"
          class="w-100"
          v-if="activities.length == 0"
        ></Alert>
        <app-collapse v-else>
          <activity-collapse
            v-for="activity in urgencies"
            :key="activity.id"
            :title="activity.name"
            @editClicked="openEditActivityModal(activity)"
            @deleteClicked="onDeleteActivity(activity)"
          >
            <b-container>
              <b-row class="justify-content-start">
                <b-col cols="12">
                  <h4 class="">
                    <feather-icon
                      class="align-middle"
                      size="20"
                      icon="FileTextIcon"
                    />
                    المعلومات الأساسية
                  </h4>
                </b-col>

                <b-col
                  lg="6"
                  sm="12"
                  v-for="(item, key) in mainInfo"
                  :key="key"
                >
                  <info-card :label="item.label" :value="activity[key]" />
                </b-col>
                <b-col lg="6" sm="12">
                  <info-card
                    :label="selectedInfo.services.label"
                    :value="
                      activity['activityServices']
                        .map((el) => el.name_ar)
                        .join(' , ')
                    "
                  />
                </b-col>
                <b-col lg="6" sm="12">
                  <info-card
                    :label="selectedInfo.ageCategories.label"
                    :value="
                      activity['categories'].map((el) => el.name_ar).join(' , ')
                    "
                  />
                </b-col>
              </b-row>
            </b-container>
          </activity-collapse>
        </app-collapse>
        <pagination
          @input="currentPage = $event"
          :total-rows="pagination.total_row"
          :per-page="pagination.per_page"
          :value="parseInt(pagination.current_page)"
          align="end"
        >
        </pagination>
      </b-tab>
      <template #tabs-end>
        <b-button
          v-if="canAddTransaction"
          @click="newActivityModal = true"
          variant="success"
          class="ml-auto"
          size=""
        >
          <feather-icon size="15" class="mr-25" icon="PlusIcon" />
          إضافة نشاط
        </b-button>
      </template>
    </b-tabs>

    <activity-modal
      @confirm="onNewActivity"
      :loading="working"
      v-model="newActivityModal"
      :activityType="type"
    />
    <activity-modal
      @confirm="onUpdateActivity"
      :loading="working"
      ref="editActivityModal"
      v-model="editActivityModal"
      :intializeForm.sync="editActivityForm"
      :activityType="type"
    />
  </div>
</template>

<script>
import {
  BButton,
  BContainer,
  BCol,
  BRow,
  BFormInput,
  BFormGroup,
  BDropdown,
  BDropdownItem,
  BTabs,
  BTab,
} from "bootstrap-vue";
import InfoCard from "@/components/InfoCard.vue";
import dataTable from "@/components/data-table";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import ActivityCollapse from "../../components/ActivityCollapse";
import ActivityModal from "../../components/ActivityModal.vue";
import editSidebar from "../../components/SideBar.vue";
import { mapActions, mapGetters } from "vuex";
import Alert from "@/components/Alert.vue";
import Pagination from "@/components/pagination";
export default {
  components: {
    BTabs,
    BTab,
    BButton,
    BContainer,
    BCol,
    BRow,
    InfoCard,
    AppCollapseItem,
    AppCollapse,
    ActivityCollapse,
    ActivityModal,
    dataTable,
    editSidebar,
    BFormInput,
    BFormGroup,
    BDropdown,
    BDropdownItem,
    Alert,
    Pagination,
  },
  data() {
    return {
      editActivityForm: {},
      editActivityModal: false,
      newActivityModal: false,
      activeTab: 0,
      type: null,
      currentPage: 1,
      mainInfo: {
        name: {
          label: "الاسم",
        },
        objectives: {
          label: " الأهداف",
        },
      },
      selectedInfo: {
        services: {
          label: "الخدمات",
        },
        ageCategories: {
          label: "الفئات المستهدفة",
        },
        program: {
          label: "البرامج",
        },
      },
    };
  },
  watch: {
    activeTab: {
      handler(val) {
        if (val === 0) this.type = true;
        else if (val === 1) this.type = false;
      },
      immediate: true,
    },
    type: {
      handler(val) {
        this.getActivities({ type: val, page: this.currentPage });
      },
      immediate: true,
    },
    currentPage(val) {
      this.getActivities({ type: this.type, page: val });
    },
  },
  methods: {
    ...mapActions("ProgramsAndActivities/Activities", [
      "getActivities",
      "addActivity",
      "editActivity",
      "deleteActivity",
    ]),
    async onNewActivity(payload) {
      await this.addActivity({
        ...payload,
        activity_type: this.type,
      });
      this.newActivityModal = false;
      this.getActivities({ type: this.type, page: this.currentPage });
    },
    async onUpdateActivity(payload) {
      await this.editActivity({
        ...payload,
        activity_type: this.type,
      });
      this.editActivityModal = false;
      this.getActivities({ type: this.type, page: this.currentPage });
    },
    onDeleteActivity(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف النشاط", {
          title: "تأكيد حذف النشاط",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) await this.deleteActivity(id);
          this.getActivities({ type: this.type, page: 1 });
        });
    },
    openEditActivityModal(activity) {
      var activityForm = {
        id: activity.id,
        name: activity.name,
        objectives: activity.objectives,
        service_ids: activity.activityServices.map((el) => el.id),
        category_ids: activity.categories.map((el) => el.id),
      };
      if (this.type) activityForm.program_id = activity.program.id;
      this.editActivityForm = { ...activityForm };

      this.$refs.editActivityModal.init(this.editActivityForm);
      this.editActivityModal = true;
    },
  },
  computed: {
    ...mapGetters("ProgramsAndActivities/Activities", [
      "activities",
      "urgencies",
      "loading",
      "working",
      "pagination",
    ]),
    ...mapGetters("NgoProfile", [ "canAddTransaction"]),
  },
  mounted() {
    this.mainInfo = {
      name: {
        label: "الاسم",
      },
      objectives: {
        label: " الأهداف",
      },
    };
    this.selectedInfo = {
      services: {
        label: "الخدمات",
      },
      ageCategories: {
        label: "الفئات المستهدفة",
      },
      program: {
        label: "البرنامج",
      },
    };
  },
};
</script>

<style lang="scss">
.info-card {
  border: 1px solid #f2f2f2;
  border-radius: 7px;
}

.header-title-h {
  display: flex;
  align-items: center;
  gap: 7px;
}
</style>
